// @flow strict

import React from 'react'
import styles from './SectionWrapper.module.scss'
import { type PropsWithChildren } from '@mondough/public-web-components'
import cx from 'classnames'

export type SectionTheme = 'dark' | 'grey' | 'light' | 'transparent' | 'brand'

export const SectionThemes: { [k: string]: SectionTheme } = {
  DARK: 'dark',
  LIGHT: 'light',
  GREY: 'grey',
  TRANSPARENT: 'transparent',
  BRAND: 'brand',
}

type Flags = { [k: string]: string | number }

export const getSectionTheme = (
  flags: Flags,
  defaultTheme: SectionTheme,
): SectionTheme => {
  if (
    flags &&
    typeof flags.theme === 'string' &&
    SectionThemes[flags.theme] != null
  ) {
    return SectionThemes[flags.theme]
  }

  return defaultTheme
}

export const SectionWrapper = ({
  className,
  contentClassName,
  theme,
  children,
  id,
}: PropsWithChildren<{
  className?: string,
  contentClassName?: string,
  id?: string,
  theme: SectionTheme,
}>) => (
  <section className={cx(styles[theme], className)} id={id}>
    <div className={contentClassName || styles.content}>{children}</div>
  </section>
)
